import { render } from "./WykresyMilena.vue?vue&type=template&id=196e08b0&ts=true"
import script from "./WykresyMilena.vue?vue&type=script&lang=ts"
export * from "./WykresyMilena.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__